<template>
    <div>
        <notification-panel-header :notification="notification">
        </notification-panel-header>

        <notification-comment :notification="notification" entityType="issue">
        </notification-comment>
    </div>
</template>

<script>
  import notificationPanelHeader from './notification-components/notification-panel-header'
  import notificationComment from './notification-components/notification-comment'

  export default {
    name: "notification-IssueCommented",

    props: {
      notification: { type: Object, required: true }
    },

    components: {
      notificationPanelHeader,
      notificationComment
    },
  }
</script>

<style scoped>

</style>